import { NavContent } from "./NavContent";
import { NormativaHome } from "./NormativaHome";
import { pathNormativaHome } from "../../businessLogic/constants/path";
import { anchorOrigin, autoHideDuration, maxSnack } from "../../businessLogic/constants/notiStack";
import { SnackbarProvider } from "notistack";

export const normativa = () => [
  {
    target: "$ONE_LAYOUT_NAV_CONTENT",
    handler: {
      component: NavContent,
      props: {
        basePath: pathNormativaHome
      }
    }
  },
  {
    target: "$ONE_LAYOUT_ROUTE",
    handler: {
      exact: true,
      path: pathNormativaHome,
      element: <SnackbarProvider anchorOrigin={anchorOrigin} autoHideDuration={autoHideDuration} maxSnack={maxSnack}><NormativaHome basePath={pathNormativaHome} /></SnackbarProvider>
    }
  }
];
